import * as React from "react"
import { Helmet } from "react-helmet"
import "../../../ns_components/default.css"
import * as classes from "./layout.module.css"

import Header from "./header"



const Layout = ({ location, children }) => {
  const rootPath = `${__PATH_PREFIX__}/`
  const isRootPath = location.pathname === rootPath

  /*
  React.useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://kit.fontawesome.com/ddcddfcbec.js";
    script.async = true;
    script.crossOrigin="anonymous";

    document.body.appendChild(script);
  }, []);
  */

  return (
    <div data-is-root-path={isRootPath} className={'global-wrapper '+classes.bodyStyle}>
      <Helmet>
        <link
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css"
          integrity="sha384-1BmE4kWBq78iYhFldvKuhfTAU6auU8tT94WrHftjDbrCEXSU1oBoqyl2QvZ6jIW3"
          crossOrigin="anonymous"
        />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
        <link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;1,100;1,200;1,300;1,400;1,500;1,600&display=swap" rel="stylesheet"></link>
        <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.15.4/css/all.css" integrity="sha384-DyZ88mC6Up2uqS4h/KRgHuoeGwBcD4Ng9SiP4dIRy0EXTlnuz47vAwmeGwVChigm" crossOrigin="anonymous"></link>
      </Helmet>
      <header className="global-header">
        <Header/>
      </header>
      <main  style={{minHeight:"600px",paddingBottom:"100px"}}>{children}</main>
      <footer className={"ns-footer "+classes.footer}>
        <div id="bottom" className={classes.bottom}>
        © {new Date().getFullYear()}, Built with
        {` `}
        <a href="https://nextsailor.com">nextSailor</a>
        </div>
      </footer>
    </div>
  )
}

export default Layout